import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API } from '../api';
import { setCompany } from '../redux/actions';

export default function useRefreshCompany() {
    const dispatch = useDispatch();
    const loggedIn = useSelector((state) => state.user.loggedIn);

    useEffect(() => {
        if (!loggedIn) return undefined;
        const controller = new AbortController();

        API.get('/company/', { signal: controller.signal })
            .then(({ data }) => dispatch(setCompany(data)))
            .catch((err) => {
                // Ignore intentional aborts (component unmount / navigation).
                if (err?.name !== 'AbortError') {
                    console.error('Error al refrescar company:', err);
                }
            });

        return () => controller.abort();
    }, [loggedIn, dispatch]);
}
